module.exports = __webpack_public_path__ + "img/attack.c7e066a8.png";